/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Pss
 */
export interface Pss {
    /**
     * is the user allowed to use the PSS
     * @type {boolean}
     * @memberof Pss
     */
    allowed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Pss
     */
    mmsi?: number;
    /**
     * 
     * @type {string}
     * @memberof Pss
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Pss
     */
    uuid?: string;
}

/**
 * Check if a given object implements the Pss interface.
 */
export function instanceOfPss(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PssFromJSON(json: any): Pss {
    return PssFromJSONTyped(json, false);
}

export function PssFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pss {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowed': !exists(json, 'allowed') ? undefined : json['allowed'],
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
    };
}

export function PssToJSON(value?: Pss | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowed': value.allowed,
        'mmsi': value.mmsi,
        'name': value.name,
        'uuid': value.uuid,
    };
}

